import React from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { IoArrowBackOutline } from 'react-icons/io5';
import Navbar from '../lab/Navbar';
import LicenseCard from './LicenseCard';
import labService from '../lab/labService';
import './css/WalletContent.css';

const AddLicenseAdmin = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const userEmail = location.state?.userEmail || "User";

  const licenses = [
    { id: 'one_nano', title: 'One nanoform', sub: 'specific endpoints', price: '99.00', info: 'Starts with', note: 'for one endpoint', perks: ['Test one nanoform', 'Choose only endpoints you need'] },
    { id: 'many_nano', title: 'Many nanoforms', sub: 'specific endpoints', price: '499.00', info: 'Starts with', note: 'for one endpoint', perks: ['Test as many nanoforms as you want', 'Valid for 12 months'] },
    { id: 'one_nano_all', title: 'One nanoform', sub: 'all endpoints', price: '2999.00', note: 'for all endpoints', perks: ['Test one nanoform', 'All endpoints available'] },
    { id: 'substance_all', title: 'One substance', sub: 'all endpoints', price: '14999.00', info: 'Starts with', perks: ['As many nanoforms as you want', 'All endpoints for Substance'] },
  ];

  const handleAssign = async (license) => {
    const token = JSON.parse(localStorage.getItem('user'))?.access;
    const confirmAssign = window.confirm(`Assign "${license.title}" to ${userEmail}?`);

    if (confirmAssign) {
      try {
        await labService.adminAssignLicense(id, license.id, token);
        alert("License assigned successfully!");
        navigate(`/manage-licences/${id}`);
      } catch (error) {
        alert("Error: " + (error.response?.data?.detail || "Failed to assign license"));
      }
    }
  };

  return (
    <div className='lab-container'>
      <Navbar />
      <main className="main-wrapper" style={{ padding: '40px' }}>
        <header style={{ display: 'flex', alignItems: 'center', marginBottom: '30px', gap: '20px' }}>
          <IoArrowBackOutline
            style={{ fontSize: '32px', cursor: 'pointer', color: '#1B4480' }}
            onClick={() => navigate(-1)}
          />
          <div>
            <h2 className='h2-title' style={{ margin: 0 }}>Assign New License</h2>
            <p style={{ color: '#666', margin: 0 }}>Target User: <strong>{userEmail}</strong></p>
          </div>
        </header>

        <div className="license-grid">
          {licenses.map((item) => (
            <LicenseCard
              key={item.id}
              {...item}
              buttonText="Assign to User"
              onChoose={() => handleAssign(item)}
            />
          ))}
        </div>
      </main>
    </div>
  );
};

export default AddLicenseAdmin;
